import React from 'react';
import {
  Box, Center, Spinner, Text,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-named-as-default
import useTaskSubmissionController from '../hooks/useTaskSubmissionController';
import { Task, TaskScope, TaskTypeEnum } from '../types';
import SubmitButton from './components/SubmitButton';

interface ActivityComposerProps {
  task: Task;
  readonly?: boolean;
  testID?: string;
  isLoading?: boolean;
  taskScope: TaskScope;
}

const ActivityComposer: React.FC<ActivityComposerProps> = ({
  task,
  readonly = false,
  testID = 'response-composer',
  isLoading = false,
  taskScope,
}) => {
  const isTasksLoading = isLoading;
  const { submit } = useTaskSubmissionController({
    taskScope,
    taskType: task?.type as TaskTypeEnum,
    formalReq: task?.evaluation?.formalCriteria,
  });
  const { t } = useTranslation();
  if (isTasksLoading || !task) {
    return (
      <Center testID={`${testID}-loading`}>
        <Spinner size="small" />
      </Center>
    );
  }

  return (
    <Box flex={1} testID={testID}>
      <Center flex={1} px="$6">
        <Text size="sm" color="$textHint" mb="$4">
          {t('student.task.composer.messages.activity-composer.message')}
        </Text>
        <SubmitButton
          show
          isDisabled={readonly}
          onSubmit={() => submit()}
          label={t('student.task.composer.buttons.mark-as-done')}
        />
      </Center>
    </Box>
  );
};

export default ActivityComposer;
